import ToolbarButton from "../Toolbar/toolbarButton";
import { useAppDispatch} from "../../../store/hooks";
import { SavePlanData } from "../../../store/ioThunk";

interface ToolbarButtonOpenProps {
  icon: '.png';
  tooltip: string;
  toolname: string;
}

const ToolbarButtonOpen = ({ icon, tooltip, toolname }: ToolbarButtonOpenProps) => {
  const dispatch = useAppDispatch();

  return (
    <ToolbarButton
      onClick={e => {dispatch(SavePlanData())}}
      icon={icon}
      tooltip={tooltip}
      toolname={toolname}
    />
  )
}

export default ToolbarButtonOpen;
